module.exports = "query GetPlanAddonsDescriptions {\n  planAddonsDescriptions {\n    ...PlanDescriptionFragment\n  }\n}\n"